import React from 'react';
import cn from 'classnames';

import {IColumn, SetOrderByType} from 'shared/ui/Table/Table';
import SortableTh from 'shared/ui/Table/SortableTh/SortableTh';
import IOrderBy from 'shared/model/IOrderBy';
import {isTranslate} from 'shared/lib/lang';

import styles from './SortableTableHead.module.scss';

interface ISortableTableHeadProps {
    columns: IColumn[],
    sort?: IOrderBy,
    set?: SetOrderByType,
}

const SortableTableHead: React.FC<ISortableTableHeadProps> = (
    {
        columns,
        sort,
        set,
    }) => {
    return (
        <thead>
            <tr className={cn(
                styles.wrapper,
                styles[isTranslate() ? 'enThead' : 'ruThead'],
            )}>
                {columns.map((col, idx) => (
                    col.sort
                        ? (
                            <SortableTh
                                key={idx}
                                sort={sort}
                                setSort={set}
                                column={col}
                            />
                        )
                        : <th key={idx} className={styles.th}>{col.label}</th>
                ))}
            </tr>
        </thead>
    );
};

export default React.memo(SortableTableHead);